module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/person-advising-other-person-8b81e9b342078af06e79d2c5a86a1ceb.jpg";